/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RuntimeError/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import GoToFrontDesk01 from 'DesignSystem/Svgs/GoToFrontDesk01/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function RuntimeError({
  children,
  viewPath = "/App/RuntimeError"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="RuntimeError.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-2rUDGi': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="RuntimeError.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="RuntimeError.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Something went wrong...
</span>
<span
  data-testid="RuntimeError.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Please see the front desk for assistance
</span>
<GoToFrontDesk01
  viewPath={`${viewPath}/GoToFrontDesk01`}
 height={300}
 width={400}
/>
</div>
</div>
{children}
</React.Fragment>)
}